



















import { computed, defineComponent } from '@vue/composition-api';
import { Address, Area } from '@/store/types';
import { createContactAddressHref, createFieldLocationHref } from './FieldAddress';

export default defineComponent({
	props: {
		address: { type: Object as () => Address, required: true },
		area: { type: Object as () => Area, required: true },
	},
	setup({ address, area }) {
		const contactAddressHref = computed(() => createContactAddressHref(address));
		const fieldLocationHref = computed(() => createFieldLocationHref(area));

		return {
			contactAddressHref,
			fieldLocationHref,
		};
	},
});
